export const styles = {
  title: {
    textDecoration: 'none',
    color: 'black',
  },
} as const;
